import React from "react";
import styled from "styled-components";
import {
  INVESTABLE_GLYPHS,
  resolveInvestableIcon,
} from "./investable-icons";

/** Sterling, from the design system: IconPark's own `pound` is the # key. */
const PoundGlyph = ({ size }: { size: number }): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(5.875 3.185)">
      <path
        d="M7.36865 0C8.59232 0 9.76373 0.219516 10.8829 0.658549C11.3203 0.830137 11.4983 1.33975 11.3024 1.76682C11.0977 2.21318 10.5652 2.39646 10.1083 2.21659C9.17683 1.84991 8.27155 1.66658 7.39246 1.66658C6.41632 1.66658 5.67826 1.91259 5.17829 2.40463C4.68625 2.89667 4.44024 3.69821 4.44024 4.80926V8.32098H8.70786C9.12534 8.32098 9.46377 8.65941 9.46377 9.07689C9.46377 9.49437 9.12534 9.8328 8.70786 9.8328H4.44024V12.4636C4.44024 13.2572 4.30929 13.9239 4.0474 14.4635C3.79345 15.0032 3.37283 15.4476 2.78556 15.7968H11.3327C11.839 15.7968 12.2493 16.2071 12.2493 16.7134C12.2493 17.2196 11.839 17.63 11.3327 17.63H0.934215C0.418263 17.63 0 17.2117 0 16.6958C0 16.2603 0.308516 15.8972 0.705571 15.7183C1.86209 15.197 2.44034 14.1201 2.44034 12.4874V9.8328H0.839241C0.421762 9.8328 0.0833288 9.49437 0.0833288 9.07689C0.0833288 8.65941 0.421762 8.32098 0.839241 8.32098H2.44034V4.55928C2.44034 3.14666 2.88476 2.0356 3.77361 1.22612C4.66245 0.408708 5.86079 0 7.36865 0Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const GlyphWrap = styled.span`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  color: inherit;
`;

export interface InvestableGlyphProps {
  /** IconPark name from the investable, if it has one. */
  icon?: string | null;
  /** Decides the fallback when there is no icon. */
  investableType?: string | null;
  size?: number;
  testID?: string;
}

/**
 * The investable's icon. One component for every surface that shows it, so a
 * deal, its fund and its holding cannot end up drawing different things.
 * Takes its colour from the parent, like the tokened icons beside it.
 */
export const InvestableGlyph = ({
  icon,
  investableType,
  size = 20,
  testID,
}: InvestableGlyphProps): JSX.Element => {
  const name = resolveInvestableIcon(icon, investableType);

  return (
    <GlyphWrap
      aria-hidden="true"
      data-testid={testID}
      data-investable-icon={name}
    >
      {name === "pound" ? (
        <PoundGlyph size={size} />
      ) : (
        React.createElement(INVESTABLE_GLYPHS[name], {
          theme: "outline",
          size,
          fill: "currentColor",
          strokeWidth: 3,
        })
      )}
    </GlyphWrap>
  );
};
